export const HEADER_CELL_WIDTH = "26.5rem";
export const HEADER_CELL_WIDTH_MOBILE = "9.2rem";
export const HEADER_CELL_WIDTH = "26.5rem";
export const HEADER_CELL_WIDTH_MOBILE = "9.2rem";
